import { render } from "./lockCircleIcon.vue?vue&type=template&id=7b3f1ee8"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__